import { AppState } from "../store";

const getPartsState = (state: AppState) => state.parts;

export type GetPartsStateType = ReturnType<typeof getPartsState>;

export default getPartsState;
